import {
  archive,
  cancelRun,
  create,
  createDraft,
  get,
  getCaseWorld,
  getGameWorld,
  getRun,
  getStartingWorld,
  list,
  listAuthorCandidates,
  listResults,
  listRuns,
  listWorlds,
  publishDraft,
  removeAuthor,
  saveDraft,
  setAuthor,
  setCaseNotes,
  setRunNotes,
  setWorld,
  startRun,
} from "./endpoints";

export { service } from "./endpoints";
export {
  EvalCase,
  EvalCasePlayer,
  EvalDetail,
  EvalDraft,
  EvalDraftDetails,
  EvalFile,
  EvalListing,
  EvalRun,
  EvalTrialUsage,
  EvalVersion,
  EvalVersionStatus,
  ResultPoint,
  RubricSection,
  RunDetail,
  Scorecard,
} from "./schemas";

export const contract = {
  list,
  create,
  get,
  archive: { set: archive },
  drafts: { create: createDraft, set: saveDraft, publish: publishDraft },
  authors: { set: setAuthor, delete: removeAuthor },
  authorCandidates: { list: listAuthorCandidates },
  cases: { notes: { set: setCaseNotes } },
  runs: {
    list: listRuns,
    create: startRun,
    get: getRun,
    cancel: cancelRun,
    notes: { set: setRunNotes },
  },
  results: { list: listResults },
  worlds: { list: listWorlds, set: setWorld },
  startingWorld: { get: getStartingWorld },
  versions: { cases: { world: { get: getCaseWorld } } },
  games: { world: { get: getGameWorld } },
} as const;
